import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
export default function TopBar(props) {
  const [user, setUser] = useState(props.user);
  const navigate = useNavigate();
  function logout() {
    localStorage.removeItem("damghaState");
    return navigate("/");
  }
  return (
    <div className="flex justify-between">
      <Helmet>
        <title>مشروع الدمغة</title>
      </Helmet>
      <div>{user.name}</div>
      <div onClick={() => logout()} className="cursor-pointer">
        تسجيل خروج
      </div>
    </div>
  );
}
